import type { MessageStatus } from './types';

export const statusLabels: Record<MessageStatus, string> = {
  PENDING: 'Pending', ACCEPTED: 'Accepted', SENT: 'Sent', DELIVERED: 'Delivered', READ: 'Read',
  FAILED: 'Failed', UNKNOWN: 'Unknown', SUPPRESSED: 'Suppressed'
};
const descriptions: Record<MessageStatus, string> = {
  PENDING: 'Recorded before sending. No provider response has been recorded yet.',
  ACCEPTED: 'Meta accepted the request. Delivery has not been confirmed.',
  SENT: 'Meta reports the message was sent.', DELIVERED: 'Meta confirmed delivery to the recipient.',
  READ: 'Meta reported that the recipient read the message.', FAILED: 'The send request or delivery failed.',
  UNKNOWN: 'No usable response was received. The message may have been accepted.',
  SUPPRESSED: 'No eligible recipient was found. Check the user status and test-user proxy mappings.'
};
export default function MessageStatusBadge({ status }: { status: MessageStatus }) {
  const tone = status === 'READ' || status === 'DELIVERED' ? 'success' : status === 'FAILED' ? 'danger'
    : status === 'UNKNOWN' || status === 'SUPPRESSED' ? 'warning' : 'neutral';
  return <span className={`pa-badge ${tone}`} title={descriptions[status]}>{statusLabels[status] ?? status}</span>;
}
